/**
 * @generated SignedSource<<158a8556a20c7a1708b21c491b6daf0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionBidsDetails_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"useAuctionPricing_item">;
  readonly " $fragmentType": "PdpSharedAuctionBidsDetails_item";
};
export type PdpSharedAuctionBidsDetails_item$key = {
  readonly " $data"?: PdpSharedAuctionBidsDetails_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionBidsDetails_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionBidsDetails_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "page",
          "value": "pdp"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useAuctionPricing_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "7d7c6a6aa9ef81d0c3910a48b9297e25";

export default node;
